import axios from "axios";
import { getApiBaseUrl } from "../config/api";

export async function submitStudentApplication(payload) {
    const { data } = await axios.post(`${getApiBaseUrl()}/StudentApplication/public`, payload);
    return data;
}

export async function fetchSchoolApplications(schoolId, { status = "Submitted" } = {}) {
    const params = status ? { status } : {};
    const { data } = await axios.get(`${getApiBaseUrl()}/StudentApplication/school/${schoolId}`, {
        params,
    });
    return Array.isArray(data) ? data : [];
}

export async function approveStudentApplication(applicationId, body) {
    const { data } = await axios.put(
        `${getApiBaseUrl()}/StudentApplication/${applicationId}/approve`,
        body,
    );
    return data;
}

export async function rejectStudentApplication(applicationId, body) {
    const { data } = await axios.put(
        `${getApiBaseUrl()}/StudentApplication/${applicationId}/reject`,
        body,
    );
    return data;
}
